import React from "react";

export function Links() {
    return (
        <>
        <center>
        <div class="right2">
            <br/>
            <br/>
            <br/>
            <br/>
            <br/>
<h1 className="text-5xl md:text-5xl font-bold mb-6">Links</h1><hr/>

<a href="http://www.monroefireprevdis1.com/SmokeApp/">Online Smoke Detector Application</a><br/>
<a href="http://www.monroefireprevdis1.com/">Monroe Township Fire District #1 Fire Prevention - Fire Prevention/Smoke Detector Inspection Information</a><br/>
<a href="http://www.mtvfc1.com/">Monroe Township Fire District #1 - (Monroe Volunteer Fire Company)</a>  <br/>

<a href="http://www.station57.org/">Monroe Township Fire District #2</a> <br/>
<a href="http://www.mtfd3.com/">Monroe Township Fire District #3 - (Central Fire Department)</a> <br/>
<a href="http://www.avec1.org/">Applegarth Volunteer Engine Co #1</a>

<p><u>References</u>:</p>
<ul>
<li><a href="http://www.nj.gov/dca/divisions/dfs/codes/">New Jersey Division of Community Affairs</a></li>
<li><a href="http://www.lexisnexis.com/hottopics/njcode/">New Jersey Administrative Code Research Tool (search engine)</a></li>
<li><a href="http://www.state.nj.us/dca/divisions/dlgs/programs/au_docs/40a_14_70.pdf">Fire  district designation, procedure, and election of commissioners</a></li>
</ul>
<center>

</center>
</div>
        </center>
        </>
    )
}